module.exports = __webpack_public_path__ + "img/能源设备管理.9f9375ca.png";